var map = {
	"./absolut.png": 5697,
	"./alfa.png": 5765,
	"./domrf.png": 3990,
	"./gazprom.png": 6681,
	"./mts.png": 4380,
	"./otkrytie.png": 2218,
	"./psb.png": 1159,
	"./raiffeisen.png": 104,
	"./rencredit.png": 2338,
	"./rosbank.png": 5466,
	"./rshb.png": 3379,
	"./sber.png": 9198,
	"./smp.png": 8482,
	"./sovcom.png": 747,
	"./tinkoff.png": 6822,
	"./ubrr.png": 3818,
	"./unicredit.png": 4708,
	"./uralsib.png": 7775,
	"./vtb.png": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5684;